
import { mapActions, mapState } from 'vuex'
import eav from '@/components/tools/eav'

export default {
  components: {},
  data () {
    return {

      submitting: false
    }
  },

  computed: {

    ...mapState('customer', {
      customer: state => state.customer,
      customerAttributes: state => state.customerAttributes
    })
  },

  methods: {
    ...mapActions('customer', ['getCustomer', 'getCustomerAttributes']),

    async setLanguageSetting (item) {
      await this.$store.commit('customer/setCustomerAttribute', {
        attributeCode: 'language_setting',
        value: item
      })

      const attributeId = this.customerAttributes.language_setting.attributeId
      const found = this.customer.attributes.selects.find(select => select.attributeId === attributeId)
      if (found) {
        const {
          status
        } = await this.$axios.put('/private/customer/update-language-setting', found)
        if (status === 200) {
          await this.getCustomer()
          window.location.href = this.switchLocalePath(this.customer?.languageSetting)

          // const cookies = this.$cookies.getAll()
          // const filtered = Object.fromEntries(Object.entries(cookies)
          //   .filter(([key]) => key.includes('auth') || key.includes('cm24-uuid') || key.startsWith('_g')))
          //
          // let query = Object.entries(filtered).map(([key, value]) => `${key}=${value}`).join('&')
          //
          // if (query.length > 0) {
          //   query = '?ls=1&' + query.slice(0, -1)
          // }
          // window.location.href = this.switchLocalePath(this.customer?.languageSetting) + query
        }
      }
    },

    getOptions (attributeCode) {
      return eav.getOptions(attributeCode, this.customerAttributes).map((option) => {
        const copy = Object.assign({}, option)

        switch (copy.label) {
          case 'de':
            copy.label = 'Deutsch'
            break
          case 'en':
            copy.label = 'English'
            break
          case 'sv':
            copy.label = 'Svenska'
            break
          case 'nl':
            copy.label = 'Nederlands'
            break
          case 'da':
            copy.label = 'Dansk'
            break
          case 'es':
            copy.label = 'Español'
            break
          case 'pl':
            copy.label = 'Polski'
            break
          case 'cs':
            copy.label = 'Ceština'
            break
          default:
            break
        }

        return copy
      })
    }

  }
}

